<template>
<div class="content" v-if="dataReady">
	<!-- Content Header (Page header) -->
	<section class="content-header">
		<div class="container-fluid">
			<div class="page-header my-2">
				<c-avatar :image="family.avatar || '/network/static/img/default_family.jpg'" :title="family.name" style="position: relative; top: -5px;"></c-avatar>
				<h1>
					Семейство: {{ family.name }}
					<small v-if="family.paid"><i class="fa fa-star-o"></i></small>
				</h1>
				<div class="pull-right" v-if="family.id === $user.familyUser.family.id">
					<router-link to="/family/me/edit" data-toggle="tooltip" title="Редактирай" class="btn btn-primary"><i class="fa fa-edit"></i></router-link>
				</div>
			</div>
		</div>
	</section>

	<!-- Main Content -->
	<div class="container-fluid">

	<div>
		<ul class="nav nav-pills md-pills" role="tablist">
			<li class="nav-item"><a class="nav-link active" data-toggle="tab" role="tab" href="#basic">Профил</a></li>
			<li class="nav-item"><a class="nav-link" data-toggle="tab" role="tab" href="#about">За нас</a></li>
			<li class="nav-item"><a class="nav-link" data-toggle="tab" role="tab" href="#hs">Домашно образование</a></li>
			<li class="nav-item"><a class="nav-link" data-toggle="tab" role="tab" href="#shared">Споделено</a></li>
		</ul>
	</div>

	<div class="tab-content">
		<!-- Basic Info -->
		<div role="tabpanel" class="tab-pane active" id="basic">
			<div class="card">
			<div class="card-block">
				<div class="row">
				<div class="col-sm-6">
					<div class="p-10">
						<h4>Родители</h4>
							<div class="table-responsive">
								<table class="table table-hover">
									<tbody>
										<template v-for="(roleDescription, role) in $config.lists.familyRoles">
											<tr v-for="user in usersByRole[role]">
												<td class="align-middle text-nowrap w-25"><c-avatar :image="user.avatar || '/network/static/img/default.jpg'" :title="user.name" style="display: inline-block"></c-avatar><strong>{{ roleDescription.text }}</strong></td>
												<td class="align-middle text-nowrap">{{ user.name }}</td>
												<td class="align-middle">{{ user.interests }}</td>
												<td v-if="family.id === $user.familyUser.family.id" class="align-middle text-center" style="width: 1px">
													<template v-if="!user.user">
														<button class="btn btn-sm btn-success" title="Покани" @click="inviteUser(user)" data-toggle="modal" data-target="#inviteUserModal"><i class="fa fa-plus"></i></button>
													</template>
													<template v-else-if="$user.familyUser.id === user.id">
														<i class="fa fa-star" title="Това сте вие"></i>
													</template>
												</td>
											</tr>
										</template>
									</tbody>
								</table>
						</div>

						<hr>

						<h4>Деца</h4>

							<div class="table-responsive">
								<table class="table table-hover">
									<tbody>
										<tr v-for="child in usersByRole.child">
											<td class="w-25">
												<!--c-avatar image="/network/static/img/default.jpg"></c-avatar -->
												<strong>{{ $config.lists.childRoles[ child.role ].text }}</strong></td>
											<td>{{ child.name }}</td>
											<td>{{ getChildAge(child) }}</td>
										</tr>
									</tbody>
								</table>
						</div>
					</div>

					<hr>

					<div class="p-10">
						<h4>Контакти</h4>

						<div class="table-responsive">
							<table class="table">
								<tbody>
									<tr>
											<td class="w-25">Адрес</td>
											<td v-if="dataReady">{{ $config.lists.countries[family.country].text }} / {{ $config.lists.states[family.state].text }} {{ family.city ? '/ ' + family.city : '' }}</td>
									</tr>
									<tr>
										<td>E-mail</td>
										<td><a :href="'mailto:' + family.email">{{ family.email }}</a></td>
									</tr>
								</tbody>
							</table>
						</div>

						<h5 class="card-title" v-if="family.info.social && family.info.social.length !== 0">{{$t('label.family_social')}}</h5>
						<a class="btn btn-blue btn-tag" v-for="social in family.info.social" :href="social.url" target="_blank">{{ $config.lists.socialNetworks[social.name].text }}</a>
				</div>

			</div> <!-- col-sm-6 end -->

				<div class="col-sm-6">
					<div class="card-img">
						<img class="img-thumbnail" style="max-height: 300px;" :src="family.photo || '/network/static/img/default_family_photo.jpg'">
					</div>
					<div class="mt-1" v-if="family.info.interests">
						<h4 class="card-title">Интереси</h4>
						<button class="btn btn-light-green btn-tag" v-for="interest in family.info.interests.split(',')">{{ interest }}</button>
					</div>
				</div>
			</div>
			</div>
			</div>
			</div> <!-- end tab basic -->

			<div role="tabpanel" class="tab-pane" id="about">
				<div class="card">
				<div class="card-block">
					<h4 class="card-title">Накратко за нашето семейство</h4>
						<div class="p-10 about-text">
							{{ this.family.info.about || 'Скоро ще напишем нещо за нас...' }}
						</div>
					</div>
				</div>
			</div>

			<div role="tabpanel" class="tab-pane" id="hs">
				<div class="card">
				<div class="card-block">

					<h4 class="card-title">Опит</h4>
					<p class="card-text">{{ family.info.hsExperience }} години</p>

					<h4 class="card-title">Методи</h4>
					<table class="table table-responsive">
							<tbody>
								<tr v-for="method in family.info.hsMethods">
									<td><strong>{{ $config.lists.hsmethods[method].name }}</strong></td>
									<td>{{ $config.lists.hsmethods[method].desc }}</td>
								</tr>
							</tbody>
					</table>
				</div>

				</div>
			</div>

			<div role="tabpanel" class="tab-pane" id="shared">
				<div class="card">
					<div class="card-block">
						<h4 class="card-title">Споделени ресурси</h4>
						<div class="row">
							<div class="col-sm-6">
								<table class="table table-responsive">
										<tbody>
											<tr>
												<td><strong>Книги</strong></td>
												<td>0 (заети: 0)</td>
											</tr>
											<tr>
												<td><strong>Учебни материали</strong></td>
												<td>0</td>
											</tr>
											<tr>
												<td><strong>Връзки</strong></td>
												<td>0</td>
											</tr>
										</tbody>
								</table>
						</div>

						<div class="col-sm-6">
							<table class="table table-responsive">
								<tbody>
									<tr>
										<td><strong>Форум съобщения</strong></td>
										<td>0 (този месец: 0)</td>
									</tr>
									<tr>
										<td><strong>Форум нови теми</strong></td>
										<td>0</td>
									</tr>
								</tbody>
							</table>
						</div>

					</div>
				</div>

			</div> <!-- end card -->
		</div>

	</div> <!-- end tab-content -->

	</div>
	<div class="modal" id="inviteUserModal" tabindex="-1" role="dialog">
		<div class="modal-dialog" role="document">
			<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title">Покана за Семейна Образователна Мрежа</h5>
					<button type="button" class="close" data-dismiss="modal" aria-label="Close">
						<span aria-hidden="true">&times;</span>
					</button>
				</div>
				<div class="modal-body" v-if="invitedUser">
					<p>За да добавите {{invitedUser.name}} към мрежата, отворете този линк с неговия/нейния акаунт:</p>
					<a :href="invitedUser.invitationLink" style="word-break: break-all">{{invitedUser.invitationLink}}</a>
				</div>
				<div class="modal-body" v-else>
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-default" data-dismiss="modal">Затвори</button>
				</div>
			</div>
		</div>
	</div>
</div>

</template>

<script>
module.exports = {
	data: function () {
		return {
			family: {},
			role: '',
			dataReady: false,
			invitedUser: {}
		};
	},
	created: function () {
		this.fetchData();
	},
	watch: {
		$route: 'fetchData'
	},
	computed: {
		usersByRole: function () {
			var roles = {
				child: [],
				mother: [],
				father: [],
				son: [],
				daughter: []
			};
			for (var i = 0; i < this.family.users.length; i++) {
				var member = this.family.users[i];
				if (member.role === 'son' || member.role === 'daughter') {
					roles.child.push(member);
				}
				roles[member.role].push(member);
			}
			return roles;
		}
	},
	methods: {
		getChildAge: function (child) {
			var currentYear = new Date().getFullYear();
			return (currentYear - child.birthYear) + ' год.';
		},
		fetchData: function () {
			var familyId = 0;
			if (this.$route.params.id === 'me') {
				familyId = this.$root.user.familyUser.family.id;
			} else {
				familyId = this.$route.params.id;
			}
			this.$http.get('backend://family/' + familyId).then((response) => {
				this.family = response.body;
				if (this.family.id === this.$user.familyUser.family.id) {
					this.role = this.$user.familyUser.role;
				}
				this.dataReady = true;
			}).catch(this.$http.toastCatcher);
		},
		inviteUser: function (familyUser) {
			if (familyUser.invitationLink) {
				this.invitedUser = familyUser;
			} else {
				this.invitedUser = undefined;
				this.$http.post('backend://family/' + this.family.id + '/invite', {familyUser: familyUser.id}).then(function (response) {
					this.invitedUser = familyUser;
					this.invitedUser.invitationLink = response.body.invite;
				}).catch(this.$http.toastCatcher);
			}
		}
	}
};
</script>
<style>
.about-text {
	white-space: pre-wrap;
	word-wrap: break-word;
	font-family: inherit;
}
</style>



// WEBPACK FOOTER //
// FamilyProfile.vue?17e68ffb